<template>
	<b-modal ref="modal" title="Reset stream" :busy="loading>0">
		<b-form @submit.stop.prevent="save(); return false" id="userEditForm">
			Are you sure you want to reset the stream? This will stop the current stream.
			<br />
			<b-form-checkbox v-model="regenStreamKey">Also regenerate stream key</b-form-checkbox>
		</b-form>
		<b-alert variant="danger" :show="!!error" class="mb-0 mt-3">{{error}}</b-alert>
		<template #modal-footer="{cancel}">
			<b-spinner v-show="loading>0" small label="Loading"></b-spinner>
			<b-button size="sm" variant="danger" type="submit" form="userEditForm">
				Reset
			</b-button>
			<b-button size="sm" @click="cancel()">
				Cancel
			</b-button>
		</template>
	</b-modal>
</template>

<script>
export default {
	name: 'StreamResetModal',
	data() { return {
		user: null,
		regenStreamKey: false,
		loading: 0,
		error: null
	}},
	methods: {
		load(promise) {
			this.loading++;
			promise.catch(err => {
				this.error = err&&err.error||err.toString();
			}).finally(() => {
				this.loading--;
			});
			return promise;
		},
		show(userId) {
			this.error = null;
			this.$refs.modal.show();
			if(userId)
				this.load(this.$api.get(`user/${userId}`)).then(user => this.user = user);
		},
		async save() {
			await this.load(this.$api.post(`recreateIngestAndEgresses${this.user? `/${encodeURIComponent(this.user.id)}` : ''}`, { regenStreamKey: this.regenStreamKey })).then(() => this.$refs.modal.hide());
			this.$refs.modal.hide();
			this.$bvToast.toast(`Successfully reset stream${this.regenStreamKey ? ' and regenerated stream key' : ''}`, { title: 'Success', variant: 'success', solid: true });
			this.$emit('saved');
		},
	},
};
</script>
